var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2.6C0.25 1.30213 1.30213 0.25 2.6 0.25H21.4C22.6979 0.25 23.75 1.30213 23.75 2.6V21.4C23.75 22.6979 22.6979 23.75 21.4 23.75H2.6C1.30213 23.75 0.25 22.6979 0.25 21.4V2.6Z",
    fill: "#EBF2F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2.6C0.25 1.30213 1.30213 0.25 2.6 0.25H21.4C22.6979 0.25 23.75 1.30213 23.75 2.6V21.4C23.75 22.6979 22.6979 23.75 21.4 23.75H2.6C1.30213 23.75 0.25 22.6979 0.25 21.4V2.6Z",
    stroke: "#C2D0DA",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.486 10.644C16.304 8.3285 14.3615 6.5 12 6.5C9.98 6.5 8.246 7.812 7.6865 9.7255C6.0905 10.2795 5 11.7915 5 13.5C5 15.7055 6.7945 17.5 9 17.5H15.5C17.43 17.5 19 15.93 19 14C19 12.4255 17.965 11.074 16.486 10.644ZM14.3535 13.3535L12.3535 15.3535C12.256 15.451 12.128 15.5 12 15.5C11.872 15.5 11.744 15.451 11.6465 15.3535L9.6465 13.3535C9.5035 13.2105 9.4605 12.9955 9.538 12.8085C9.6155 12.622 9.798 12.5 10 12.5H11V10.5C11 9.948 11.448 9.5 12 9.5C12.552 9.5 13 9.948 13 10.5V12.5H14C14.202 12.5 14.3845 12.622 14.462 12.8085C14.5395 12.9955 14.4965 13.2105 14.3535 13.3535Z",
    fill: "#1D4469"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.da66b317b69418ec5255f8f373a2fe44.svg";
export { ForwardRef as ReactComponent };